module.exports = __webpack_public_path__ + "img/20-minuten.5b27390.png";